const SLEUTEL = 'toepen-herladen-na-nieuwe-versie';

function onthoud(waarde) {
    try {
        if (waarde) {
            sessionStorage.setItem(SLEUTEL, '1');
        } else {
            sessionStorage.removeItem(SLEUTEL);
        }
    } catch {
        // Privémodus of geblokkeerde opslag: dan gaat het herladen zonder rem. Dat is
        // nog altijd beter dan een lege pagina.
    }
}

function alEensHerladen() {
    try {
        return sessionStorage.getItem(SLEUTEL) === '1';
    } catch {
        return false;
    }
}

/**
 * Laadt een schermmodule, en herlaadt de pagina één keer als dat niet lukt.
 *
 * Elk scherm wordt apart ingeladen, en die bestanden dragen een inhoudshash in hun
 * naam. Zet iemand een nieuwe versie neer terwijl jij de app open hebt staan, dan
 * bestaan de bestanden waar jouw pagina naar verwijst niet meer. De volgende klik
 * naar een ander scherm liep dan dood.
 *
 * Eén keer herladen haalt de nieuwe index.html op, en die verwijst naar wat er wél
 * is. De vlag in sessionStorage voorkomt dat een echt kapotte build in een lus komt:
 * lukt het na dat herladen nog steeds niet, dan gaat de fout gewoon door.
 */
export function laadModule(laden) {
    return laden()
        .then(module => {
            onthoud(false);
            return module;
        })
        .catch(fout => {
            if (alEensHerladen()) {
                throw fout;
            }

            onthoud(true);
            window.location.reload();

            // Nooit oplossen: de pagina is toch onderweg naar buiten.
            return new Promise(() => {});
        });
}
